export default __webpack_public_path__ + "static/media/pantalla3.8dba7521.png";